import React from 'react';
import eytanimage from "../../../../Assets/Images/eytan.png"
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useTailwindBrand from '../../../../Theme/useTailwindBrand';
import { BrandButton } from '../../../../Components/shared';
const First = (props: any) => {
    const navigate = useNavigate()
    const { classes, brandConfig, common } = useTailwindBrand()
    return (
        <div>
            <div className='bg-white rounded-[20px] p-4'>
                <div className="flex items-center gap-x-4">
                    <img src={eytanimage} alt="" />
                    <p className={`font-extrabold ${common.subtitle2} ${classes.primaryText}`}>Eytan</p>
                </div>
                <div className='font-bold lg:leading-[30.01px] py-4'>
                    <p className={common.body} >Bienvenue dans l’espace de création de votre procuration pour obtenir votre déclaration SAP.
                        <br /> En nous délivrant celle-ci, vous nous permettez de faire toutes les démarches administratives à votre place. </p>
                </div>

            </div>
            <div className="flex flex-col gap-y-4">
                <BrandButton
                    onClick={() => props.callBack(1)}
                    className='w-full lg:w-max mt-14 mx-auto block  lg:text-xl rounded-full px-10 lg:py-3 py-2 font-semibold'
                    children={'C’est parti'}
                />
                <BrandButton
                    onClick={() => navigate(-1)}
                    variant='outline'
                    className='px-10 lg:py-3 mx-auto block  w-full lg:w-max py-2 lg:hidden font-semibold'
                    children={'précédent'}
                />
                {/* <Button onClick={() => props.callBack(1)} className='text-white lg:text-xl rounded-full px-10 lg:py-3 mx-auto block mt-14 w-full lg:w-max py-2' style={{ background: 'linear-gradient(180deg, #0054A3 0%, #219CFF 100%)' }}>C’EST PARTI</Button>
                <Button className='text-normal lg:text-xl rounded-full px-10 lg:py-3 mx-auto block  w-full lg:w-max py-2 lg:hidden font-semibold' onClick={() => navigate(-1)}>précédent</Button> */}
            </div>
        </div>
    );
};

export default First;